// Sample Product Data
const products = [
    {
        id: 1,
        name: 'Vestido Floral',
        price: 89.00,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=500',
        category: 'women',
        subcategory: 'dresses',
        label: 'new',
        colors: ['#ff6b6b', '#6EDDD4', '#65C7E1']
    },
    {
        id: 2,
        name: 'Camisa Linho',
        price: 35.99,
        originalPrice: 45.99,
        image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=500',
        category: 'women',
        subcategory: 'tops',
        label: 'sale',
        colors: ['#ffffff', '#A5F4F7']
    },
    {
        id: 3,
        name: 'Calças Wide Leg',
        price: 59.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1594633313593-bab3825d0caf?w=500',
        category: 'women',
        subcategory: 'bottoms',
        label: null,
        colors: ['#1a1a1a', '#8b7355']
    },
    {
        id: 4,
        name: 'Casaco Oversized',
        price: 89.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=500',
        category: 'women',
        subcategory: 'outerwear',
        label: 'new',
        colors: ['#8b7355', '#1a1a1a']
    },
    {
        id: 5,
        name: 'T-shirt Básica',
        price: 19.99,
        originalPrice: 29.99,
        image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500',
        category: 'men',
        label: 'sale',
        colors: ['#ffffff', '#1a1a1a', '#4a5568']
    },
    {
        id: 6,
        name: 'Camisa Casual',
        price: 44.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=500&h=600&fit=crop',
        category: 'men',
        label: null,
        colors: ['#4a5568', '#ffffff']
    },
    {
        id: 7,
        name: 'Calças Chino',
        price: 54.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=500',
        category: 'men',
        label: 'new',
        colors: ['#8b7355', '#1a1a1a']
    },
    {
        id: 8,
        name: 'Mala Estruturada',
        price: 69.99,
        originalPrice: 89.99,
        image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=500',
        category: 'accessories',
        label: 'sale',
        colors: ['#1a1a1a', '#8b7355']
    },
    {
        id: 9,
        name: 'Óculos de Sol',
        price: 39.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=500',
        category: 'accessories',
        label: null,
        colors: ['#1a1a1a']
    },
    {
        id: 10,
        name: 'Colar Dourado',
        price: 24.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=500',
        category: 'accessories',
        label: 'new',
        colors: ['#ffd700']
    },
    {
        id: 11,
        name: 'Saia Midi',
        price: 42.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=500',
        category: 'women',
        subcategory: 'bottoms',
        label: null,
        colors: ['#ff6b6b', '#1a1a1a']
    },
    {
        id: 12,
        name: 'Blazer Classic',
        price: 79.99,
        originalPrice: 99.99,
        image: 'https://images.unsplash.com/photo-1591369822096-ffd140ec948f?w=500',
        category: 'women',
        subcategory: 'outerwear',
        label: 'sale',
        colors: ['#1a1a1a', '#8b7355']
    },
    {
        id: 13,
        name: 'Vestido Elegante Preto',
        price: 69.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1566174053879-31528523f8ae?w=500',
        category: 'women',
        subcategory: 'dresses',
        label: null,
        colors: ['#1a1a1a']
    },
    {
        id: 14,
        name: 'Vestido Casual Verão',
        price: 39.99,
        originalPrice: 54.99,
        image: 'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=500',
        category: 'women',
        subcategory: 'dresses',
        label: 'sale',
        colors: ['#ffffff', '#ff6b6b', '#6EDDD4']
    },
    {
        id: 15,
        name: 'Vestido Longo Festa',
        price: 89.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=500',
        category: 'women',
        subcategory: 'dresses',
        label: 'new',
        colors: ['#8b7355', '#1a1a1a', '#ff6b6b']
    },
    {
        id: 16,
        name: 'Vestido Midi Listrado',
        price: 54.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500',
        category: 'women',
        subcategory: 'dresses',
        label: null,
        colors: ['#1a1a1a', '#ffffff']
    },
    {
        id: 17,
        name: 'Vestido Boho Chic',
        price: 44.99,
        originalPrice: null,
        image: 'https://images.unsplash.com/photo-1618932260643-eee4a2f652a6?w=500',
        category: 'women',
        subcategory: 'dresses',
        label: 'new',
        colors: ['#ff6b6b', '#A5F4F7', '#6EDDD4']
    }
];

const DISCOUNT_EMAIL_KEY = 'turkesa-discount-email';
const DISCOUNT_ELIGIBLE_KEY = 'turkesa-discount-eligible';
const DISCOUNT_CODE_KEY = 'turkesa-discount-code';
const DISCOUNT_DISABLED_KEY = 'turkesa-discount-disabled';
const DISCOUNT_CODES = {
    TURKESA5: 0.05,
    CARNAVAL20: 0.20
};
const readStorage = (storage, key) => {
    try {
        return storage.getItem(key);
    } catch (error) {
        console.warn('Discount storage read blocked', error);
        return null;
    }
};
const writeStorage = (storage, key, value) => {
    try {
        storage.setItem(key, value);
        return true;
    } catch (error) {
        console.warn('Discount storage write blocked', error);
        return false;
    }
};
const removeStorage = (storage, key) => {
    try {
        storage.removeItem(key);
    } catch (error) {
        console.warn('Discount storage remove blocked', error);
    }
};
const discountStorage = {
    get(key) {
        const localValue = readStorage(localStorage, key);
        if (localValue != null) return localValue;
        return readStorage(sessionStorage, key);
    },
    set(key, value) {
        const wroteLocal = writeStorage(localStorage, key, value);
        writeStorage(sessionStorage, key, value);
        return wroteLocal;
    },
    remove(key) {
        removeStorage(localStorage, key);
        removeStorage(sessionStorage, key);
    }
};

const normalizeDiscountCode = (code = '') => code.toString().replace(/\s+/g, '').toUpperCase();

const getPopupDiscountCode = () => {
    const overlay = document.getElementById('discountPopupOverlay');
    return overlay?.dataset.discountCode?.trim() || '';
};

const getStoredDiscountCode = () => normalizeDiscountCode(discountStorage.get(DISCOUNT_CODE_KEY) || '');
const setDiscountDisabled = (disabled) => {
    discountStorage.set(DISCOUNT_DISABLED_KEY, disabled ? 'true' : 'false');
};
const isDiscountDisabled = () => discountStorage.get(DISCOUNT_DISABLED_KEY) === 'true';
const setStoredDiscountCode = (code) => {
    const normalized = normalizeDiscountCode(code);
    if (normalized) {
        discountStorage.set(DISCOUNT_CODE_KEY, normalized);
        setDiscountDisabled(false);
    }
    return normalized;
};
const clearStoredDiscountCode = () => discountStorage.remove(DISCOUNT_CODE_KEY);
const getDiscountRate = (code) => DISCOUNT_CODES[code] || 0;
const isValidDiscountCode = (code) => Boolean(getDiscountRate(code));

const getDiscountEmail = () => discountStorage.get(DISCOUNT_EMAIL_KEY) || '';
const hasDiscountEmail = () => Boolean(getDiscountEmail());
const hasDiscountEligibility = () => (
    discountStorage.get(DISCOUNT_ELIGIBLE_KEY) === 'true' || hasDiscountEmail()
);

const getDiscountCode = () => {
    const storedCode = getStoredDiscountCode();
    if (storedCode && isValidDiscountCode(storedCode)) return storedCode;

    if (isDiscountDisabled()) return '';
    if (!hasDiscountEligibility()) return '';

    const popupCode = normalizeDiscountCode(getPopupDiscountCode());
    return isValidDiscountCode(popupCode) ? popupCode : '';
};

const getDiscountCheckoutUrl = () => {
    const code = getDiscountCode();
    if (!code) return '/checkout';
    return `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
};

// Cart State (synced with Shopify cart)
let cart = [];
let cartTotals = { totalPrice: 0, itemCount: 0 };
let cartRestoreAttempted = false;
const cartAvailabilityCache = new Map();
let soldOutModalElement = null;

// Local cart persistence (per cliente/email ou visitante)
const CART_STORAGE_PREFIX = 'turkesa-cart:';
const cartStorage = {
    get(key) {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            console.warn('Cart storage read blocked', error);
            return null;
        }
    },
    set(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.warn('Cart storage write blocked', error);
        }
    },
    remove(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.warn('Cart storage remove blocked', error);
        }
    }
};

const getCartStorageKey = () => {
    const customer = window.__turkesaCustomer;
    const emailKey = (customer && customer.loggedIn && customer.email)
        ? customer.email.toLowerCase()
        : 'guest';
    return `${CART_STORAGE_PREFIX}${emailKey}`;
};

const getGuestCartStorageKey = () => `${CART_STORAGE_PREFIX}guest`;

const hasCheckoutReferrer = () => {
    const referrer = document.referrer || '';
    if (!referrer) return false;
    return /\/checkout/.test(referrer) || /\/thank[_-]?you/.test(referrer) || /\/orders\//.test(referrer);
};

const hasCheckoutQuery = () => {
    try {
        const params = new URLSearchParams(window.location.search);
        return params.get('checkout') === 'success' || params.get('thank_you') === 'true';
    } catch (error) {
        return false;
    }
};

const shouldClearCartAfterCheckout = () => hasCheckoutReferrer() || hasCheckoutQuery();

const clearSavedCartSnapshots = () => {
    cartStorage.remove(getCartStorageKey());
    cartStorage.remove(getGuestCartStorageKey());
};

const persistCartSnapshot = () => {
    const key = getCartStorageKey();
    if (!cart.length) {
        cartStorage.remove(key);
        return;
    }

    const snapshot = {
        items: cart
            .filter(item => item.variantId) // só guardamos se houver variante para recriar
            .map(item => ({
                id: item.variantId,
                quantity: item.quantity
            }))
    };

    if (snapshot.items.length === 0) return;

    cartStorage.set(key, JSON.stringify(snapshot));
};

const loadSavedCart = (key = getCartStorageKey()) => {
    const raw = cartStorage.get(key);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (error) {
        cartStorage.remove(key);
        return null;
    }
};

const restoreSavedCartIfNeeded = async () => {
    if (cartRestoreAttempted) return;
    cartRestoreAttempted = true;

    const isLoggedIn = !!window.__turkesaCustomer?.loggedIn;
    const currentKey = getCartStorageKey();
    const saved = loadSavedCart(currentKey);
    // If logged in and no saved cart yet, try migrating guest snapshot
    const fallbackSaved = (!saved || !saved.items?.length) && isLoggedIn
        ? loadSavedCart(getGuestCartStorageKey())
        : null;

    const chosenSnapshot = (saved && saved.items?.length) ? saved : fallbackSaved;
    const items = chosenSnapshot?.items?.filter(item => item.id && item.quantity > 0) || [];
    if (!items.length) return;

    try {
        // If user is logged in, ensure Shopify cart reflects their snapshot (clear then restore)
        if (isLoggedIn) {
            await clearShopifyCart(true);
        }

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error('Falhou restauro do carrinho');

        // If we restored from guest while logged in, migrate snapshot to user key
        if (fallbackSaved && isLoggedIn) {
            cartStorage.set(currentKey, JSON.stringify(fallbackSaved));
        }

        await refreshCartFromShopify();
    } catch (error) {
        console.error('Não foi possível restaurar o carrinho guardado', error);
    }
};

const formatMoney = (cents) => {
    return (cents / 100).toLocaleString('pt-PT', {
        style: 'currency',
        currency: 'EUR'
    });
};

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    initializeProducts();
    initializeNovidadesCarousel();
    initializeCart().catch(console.error);
    initializeCartDiscountUI();
    bindAjaxProductForms();
    initializeCookieBanner();
    initializeMobileNav();
    initializeHeaderHoverDropdowns();
    initializeEventListeners();
    initializeAnnouncementBarScroll();
    initializeSoldOutBadgeNavigation();
});

// Listen for cart updates from other scripts (like product.js)
window.addEventListener('cartUpdated', () => {
    refreshCartFromShopify();
});

// Initialize Products
function initializeProducts() {
    const productGrid = document.getElementById('productGrid');
    if (productGrid) {
        renderProducts(products);
    }
}

// Initialize Novidades Carousel
function initializeNovidadesCarousel() {
    const novidadesTrack = document.getElementById('novidadesTrack');
    if (!novidadesTrack) return;

    // Get only new products
    const newProducts = products.filter(p => p.label === 'new');

    // Render product cards in carousel
    newProducts.forEach(product => {
        const card = createNovidadeCard(product);
        novidadesTrack.appendChild(card);
    });

    // Setup carousel navigation
    setupCarouselNavigation();
}

// Create Novidade Card
function createNovidadeCard(product) {
    const card = document.createElement('div');
    card.className = 'novidade-card';

    card.innerHTML = `
        <div class="novidade-image">
            <img src="${product.image}" alt="${product.name}">
        </div>
        <div class="novidade-info">
            <div class="novidade-name">${product.name}</div>
            <div class="novidade-price">€${product.price.toFixed(2)}</div>
            <a href="${product.id === 1 ? '/pages/product' : '#'}" class="btn-view">Ver</a>
        </div>
    `;

    return card;
}

// Setup Carousel Navigation
function setupCarouselNavigation() {
    const track = document.getElementById('novidadesTrack');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

    if (!track || !prevBtn || !nextBtn) return;

    const trackContainer = track.parentElement;
    let currentPosition = 0;
    const getCardWidth = () => {
        const firstCard = track.children[0];
        if (!firstCard) return 325;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return firstCard.getBoundingClientRect().width + gap;
    };

    const getMaxPosition = (cardWidthOverride) => {
        const cardWidth = cardWidthOverride || getCardWidth();
        const visibleCards = Math.max(1, Math.floor((trackContainer?.offsetWidth || window.innerWidth) / cardWidth));
        const hiddenCards = track.children.length - visibleCards;
        if (hiddenCards <= 0) return 0;
        return -(hiddenCards * cardWidth);
    };

    function updateButtons() {
        const maxPosition = getMaxPosition();
        prevBtn.disabled = currentPosition >= 0;
        nextBtn.disabled = currentPosition <= maxPosition;
    }

    function moveTrack(direction) {
        const step = getCardWidth();
        const maxPosition = getMaxPosition(step);
        currentPosition += direction * step;
        if (currentPosition < maxPosition) currentPosition = maxPosition;
        if (currentPosition > 0) currentPosition = 0;
        track.style.transform = `translateX(${currentPosition}px)`;
        updateButtons();
    }

    // Next button
    nextBtn.addEventListener('click', () => {
        moveTrack(-1);
    });

    // Previous button
    prevBtn.addEventListener('click', () => {
        moveTrack(1);
    });

    // Initialize button states
    updateButtons();

    // Update on window resize
    window.addEventListener('resize', () => {
        currentPosition = 0;
        track.style.transform = `translateX(0)`;
        updateButtons();
    });
}

function initializeSoldOutBadgeNavigation() {
    document.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        const badge = event.target.closest('.product-badge--sold-out');
        if (!badge) return;

        const rawUrl = (badge.dataset.soldOutUrl || badge.getAttribute('href') || '').trim();
        if (!rawUrl) return;

        event.preventDefault();
        const target = badge.getAttribute('target');
        showSoldOutModal(rawUrl, badge.dataset.soldOutName, target);
    });
}

function ensureSoldOutModal() {
    if (soldOutModalElement) return soldOutModalElement;

    const template = `
        <div id="soldOutModal" class="sold-out-modal" aria-hidden="true">
            <div class="sold-out-modal__dialog" role="dialog" aria-modal="true">
                <button type="button" class="sold-out-modal__close" data-sold-out-close aria-label="Fechar">×</button>
                <div class="sold-out-modal__badge">Esgotado</div>
                <p class="sold-out-modal__message" data-sold-out-message></p>
                <a class="sold-out-modal__notify" data-sold-out-notify>Notificar-me quando estiver disponível</a>
            </div>
        </div>`;

    document.body.insertAdjacentHTML('beforeend', template);
    soldOutModalElement = document.getElementById('soldOutModal');
    if (!soldOutModalElement) return null;

    soldOutModalElement.addEventListener('click', (event) => {
        if (event.target === soldOutModalElement || event.target.closest('[data-sold-out-close]')) {
            hideSoldOutModal();
        }
    });

    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && soldOutModalElement?.classList.contains('is-visible')) {
            hideSoldOutModal();
        }
    });

    return soldOutModalElement;
}

function showSoldOutModal(productUrl, productName, target) {
    const modal = ensureSoldOutModal();
    if (!modal) return;

    const notifyLink = modal.querySelector('[data-sold-out-notify]');
    const messageEl = modal.querySelector('[data-sold-out-message]');

    if (messageEl) {
        messageEl.textContent = productName
            ? `Desejas ser notificado quando ${productName} voltar a estar disponível?`
            : 'Desejas ser notificado quando o produto voltar a estar disponível?';
    }

    if (notifyLink) {
        notifyLink.href = productUrl;
        notifyLink.textContent = productName
            ? `Notificar-me sobre ${productName}`
            : 'Notificar-me quando estiver disponível';
        notifyLink.setAttribute('role', 'button');
        notifyLink.removeAttribute('target');
        notifyLink.removeAttribute('rel');
        if (target && target !== '_self') {
            notifyLink.setAttribute('target', target);
            notifyLink.setAttribute('rel', 'noopener');
        }
    }

    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-visible');
    document.body.classList.add('modal-open');
}

function hideSoldOutModal() {
    if (!soldOutModalElement) return;
    soldOutModalElement.classList.remove('is-visible');
    soldOutModalElement.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
}

// Render Products
function renderProducts(productsToRender) {
    const productGrid = document.getElementById('productGrid');
    productGrid.innerHTML = '';

    productsToRender.forEach(product => {
        const productCard = createProductCard(product);
        productGrid.appendChild(productCard);
    });
}

// Create Product Card
function createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'product-card';
    card.dataset.category = product.category;
    card.dataset.subcategory = product.subcategory || '';
    card.dataset.label = product.label || '';

    const priceHTML = product.originalPrice
        ? `<div class="product-price sale">
             <span class="original">${product.originalPrice.toFixed(2)}€</span>
             <span class="discounted">${product.price.toFixed(2)}€</span>
           </div>`
        : `<div class="product-price">${product.price.toFixed(2)}€</div>`;

    const labelHTML = product.label
        ? `<span class="product-label ${product.label}">${product.label === 'new' ? 'Novo' : 'Sale'}</span>`
        : '';

    const colorsHTML = product.colors.map(color =>
        `<span class="color-swatch" style="background-color: ${color}"></span>`
    ).join('');
    card.innerHTML = `
        <div class="product-image">
            ${labelHTML}
            <img src="${product.image}" alt="${product.name}">
            <button class="quick-view" onclick="addToCart(${product.id})">Adicionar ao Carrinho</button>
        </div>
        <div class="product-info">
            <h3 class="product-title">${product.name}</h3>
            ${priceHTML}
            <div class="color-swatches">${colorsHTML}</div>
        </div>
    `;

    // Add click event to view product details (for Vestido Floral)
    if (product.id === 1) { // Vestido Floral
        card.style.cursor = 'pointer';
        card.addEventListener('click', (e) => {
            // Don't navigate if clicking the "Add to Cart" button
            if (!e.target.classList.contains('quick-view')) {
                window.location.href = '/pages/product';
            }
        });
    }

    return card;
}

// Sync cart with Shopify and render drawer
async function refreshCartFromShopify(options = {}) {
    const { skipPersist = false } = options;
    try {
        const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('Erro ao obter carrinho');

        const data = await response.json();
        cartTotals = { totalPrice: data.total_price, itemCount: data.item_count };

        cart = data.items.map(item => {
            const handleMatch = item.url ? item.url.match(/\/products\/([^?]+)/) : null;
            const handle = item.handle || (handleMatch ? handleMatch[1] : '');
            const cachedAvailability = cartAvailabilityCache.has(item.variant_id)
                ? cartAvailabilityCache.get(item.variant_id)
                : undefined;
            const availability = typeof item.available === 'boolean'
                ? item.available
                : (typeof item.variant_available === 'boolean' ? item.variant_available : cachedAvailability);

            return {
                id: item.key,
                variantId: item.variant_id,
                name: item.product_title,
                price: (item.final_price != null ? item.final_price : item.price), // preço unitário já com desconto automático
                originalPrice: (item.original_price != null ? item.original_price : item.price), // preço unitário antes do desconto
                quantity: item.quantity,
                image: item.image,
                size: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
                handle,
                available: availability
            };
        });

        renderCart();
        updateCartCount();
        if (!skipPersist) {
            persistCartSnapshot();
        }
        hydrateCartAvailability();
    } catch (error) {
        console.error(error);
        cartTotals = { totalPrice: 0, itemCount: 0 };
        cart = [];
        renderCart();
        updateCartCount();
        if (!skipPersist) {
            persistCartSnapshot();
        }
    }
}

// Clear Shopify cart completely (used when forcing empty cart for guests)
async function clearShopifyCart(skipPersist = false) {
    try {
        const response = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        if (!response.ok) throw new Error('Erro ao limpar carrinho');
    } catch (error) {
        console.error('Não foi possível limpar o carrinho', error);
    } finally {
        cartTotals = { totalPrice: 0, itemCount: 0 };
        cart = [];
        renderCart();
        updateCartCount();
        if (!skipPersist) {
            persistCartSnapshot();
        }
    }
}

// Add to Cart (Shopify AJAX)
async function addToCart(variantId) {
    if (!variantId) return;

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!response.ok) throw new Error('Erro ao adicionar ao carrinho');

        await refreshCartFromShopify();
        showCartSidebar();
    } catch (error) {
        console.error(error);
        alert('Não foi possível adicionar ao carrinho. Tenta novamente.');
    }
}

// Remove from Cart
async function removeFromCart(lineKey) {
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
        });

        if (!response.ok) throw new Error('Erro ao remover item');

        await refreshCartFromShopify();
    } catch (error) {
        console.error(error);
        alert('Não foi possível remover o item. Tenta novamente.');
    }
}

// Update Quantity
async function updateQuantity(lineKey, change) {
    const item = cart.find(item => item.id === lineKey);
    if (!item) return;

    const newQuantity = item.quantity + change;

    const payload = {
        // Use the line item key so Shopify respects per-line properties and stock
        id: lineKey,
        quantity: Math.max(newQuantity, 0)
    };

    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error('Erro ao atualizar quantidade');

        await refreshCartFromShopify();
    } catch (error) {
        console.error(error);
        alert('Não foi possível atualizar a quantidade. Tenta novamente.');
    }
}

// Update Cart (alias for compatibility)
function updateCart() {
    refreshCartFromShopify();
}

const getTranslationText = (key, fallback) => {
    if (typeof translations !== 'object') return fallback;
    const lang = window.TurkesaLanguage?.getCurrentLanguage?.() || localStorage.getItem('turkesa-language') || 'pt';
    return translations?.[lang]?.[key] || fallback;
};

const setCartDiscountMessage = (message, type) => {
    const messageEl = document.getElementById('cartDiscountMessage');
    if (!messageEl) return;
    messageEl.textContent = message || '';
    messageEl.classList.remove('is-error', 'is-success');
    if (type) {
        messageEl.classList.add(`is-${type}`);
    }
};

function initializeCartDiscountUI() {
    const input = document.getElementById('cartDiscountCode');
    const applyBtn = document.getElementById('applyDiscountBtn');
    const clearBtn = document.getElementById('clearDiscountBtn');

    if (!input || !applyBtn) return;
    if (applyBtn.dataset.discountBound === 'true') return;

    applyBtn.dataset.discountBound = 'true';

    const applyCode = () => {
        const normalized = normalizeDiscountCode(input.value);
        if (!normalized) {
            setCartDiscountMessage(getTranslationText('cartDiscountEmpty', 'Insere um código'), 'error');
            return;
        }
        if (!isValidDiscountCode(normalized)) {
            setCartDiscountMessage(getTranslationText('cartDiscountInvalid', 'Código inválido'), 'error');
            return;
        }

        setStoredDiscountCode(normalized);
        discountStorage.set(DISCOUNT_ELIGIBLE_KEY, 'true');
        setCartDiscountMessage(`${getTranslationText('cartDiscountApplied', 'Código aplicado')}: ${normalized}`, 'success');
        renderCart();
    };

    applyBtn.addEventListener('click', applyCode);
    input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            applyCode();
        }
    });
    input.addEventListener('input', () => {
        setCartDiscountMessage('');
    });

    if (clearBtn && clearBtn.dataset.discountBound !== 'true') {
        clearBtn.dataset.discountBound = 'true';
        clearBtn.addEventListener('click', () => {
            clearStoredDiscountCode();
            setDiscountDisabled(true);
            setCartDiscountMessage('');
            renderCart();
        });
    }
}

// Render Cart
function renderCart() {
    const cartItems = document.getElementById('cartItems');
    const cartTotal = document.getElementById('cartTotal');
    const cartSubtotal = document.getElementById('cartSubtotal');
    const cartDiscountRow = document.getElementById('cartDiscountRow');
    const cartDiscountLabel = document.getElementById('cartDiscountLabel');
    const cartDiscountAmount = document.getElementById('cartDiscountAmount');
    const cartDiscountApplied = document.getElementById('cartDiscountApplied');
    const cartDiscountChip = document.getElementById('cartDiscountChip');
    const clearDiscountBtn = document.getElementById('clearDiscountBtn');
    const discountInput = document.getElementById('cartDiscountCode');

    if (!cartItems || !cartTotal) return;

    const activeCode = getDiscountCode();
    const discountRate = getDiscountRate(activeCode);
    const subtotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    let discountAmount = 0;

    if (cart.length === 0) {
        cartItems.innerHTML = '<p class="empty-cart">O seu carrinho está vazio</p>';
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(0);
        cartTotal.textContent = formatMoney(0);
    } else {
        const cartHTML = cart.map(item => {
            const lineTotal = item.price * item.quantity;
            const lineOriginal = (item.originalPrice || item.price) * item.quantity;
            let priceHtml = lineOriginal > lineTotal
                ? `<div class="cart-item-price">
                    <span class="cart-price-original">${formatMoney(lineOriginal)}</span>
                    <span class="cart-price-discounted">${formatMoney(lineTotal)}</span>
                </div>`
                : `<div class="cart-item-price">${formatMoney(lineTotal)}</div>`;

            if (discountRate > 0) {
                const lineDiscount = Math.round(lineTotal * discountRate);
                discountAmount += lineDiscount;
                const discountedTotal = lineTotal - lineDiscount;
                priceHtml = `
                <div class="cart-item-price">
                    <span class="cart-price-original">${formatMoney(lineTotal)}</span>
                    <span class="cart-price-discounted">${formatMoney(discountedTotal)}</span>
                </div>`;
            }

            return `
        <div class="cart-item">
            <img src="${item.image || ''}" alt="${item.name}" class="cart-item-image">
            <div class="cart-item-info">
                <div class="cart-item-title">${item.name}${item.size ? ` - ${item.size}` : ''}</div>
                ${priceHtml}
                <div class="cart-item-quantity">
                    <button class="qty-btn" onclick="updateQuantity('${item.id}', -1)">-</button>
                    <span>${item.quantity}</span>
                    <button class="qty-btn" onclick="updateQuantity('${item.id}', 1)">+</button>
                </div>
                <button class="cart-item-remove" onclick="removeFromCart('${item.id}')">Remover</button>
            </div>
        </div>
    `;
        }).join('');

        cartItems.innerHTML = cartHTML;
    }

    if (cartSubtotal) cartSubtotal.textContent = formatMoney(subtotal);

    const totalWithDiscount = Math.max(0, subtotal - discountAmount);
    cartTotal.textContent = formatMoney(totalWithDiscount);

    const hasDiscount = discountAmount > 0 && discountRate > 0;
    if (cartDiscountRow) {
        cartDiscountRow.hidden = !hasDiscount;
    }
    if (cartDiscountLabel) {
        cartDiscountLabel.textContent = hasDiscount
            ? `${getTranslationText('cartDiscountLabel', 'Desconto')} (${activeCode})`
            : getTranslationText('cartDiscountLabel', 'Desconto');
    }
    if (cartDiscountAmount) {
        cartDiscountAmount.textContent = hasDiscount ? formatMoney(-discountAmount) : formatMoney(0);
    }

    if (cartDiscountApplied) {
        cartDiscountApplied.hidden = !activeCode;
    }
    if (cartDiscountChip) {
        cartDiscountChip.textContent = activeCode ? `${activeCode} · -${Math.round(discountRate * 100)}%` : '';
    }
    if (clearDiscountBtn) {
        clearDiscountBtn.hidden = !activeCode;
    }
    if (discountInput) {
        discountInput.value = activeCode || '';
    }
    if (activeCode) {
        setCartDiscountMessage(`${getTranslationText('cartDiscountApplied', 'Código aplicado')}: ${activeCode}`, 'success');
    }
}

async function hydrateCartAvailability() {
    const itemsToCheck = cart.filter(item =>
        item.variantId &&
        item.handle &&
        typeof item.available !== 'boolean'
    );

    if (itemsToCheck.length === 0) return;

    const uniqueHandles = [...new Set(itemsToCheck.map(item => item.handle))];
    const results = await Promise.all(uniqueHandles.map(async (handle) => {
        try {
            const response = await fetch(`/products/${handle}.js`, {
                headers: { 'Accept': 'application/json' }
            });
            if (!response.ok) return null;
            return response.json();
        } catch (error) {
            return null;
        }
    }));

    results.forEach(data => {
        if (!data || !Array.isArray(data.variants)) return;
        data.variants.forEach(variant => {
            cartAvailabilityCache.set(variant.id, variant.available);
        });
    });

    let updated = false;
    cart.forEach(item => {
        if (typeof item.available === 'boolean') return;
        if (cartAvailabilityCache.has(item.variantId)) {
            item.available = cartAvailabilityCache.get(item.variantId);
            updated = true;
        }
    });

    if (updated) renderCart();
}

// Update Cart Count
function updateCartCount() {
    const cartCount = document.getElementById('cartCount');
    if (!cartCount) return;
    cartCount.textContent = cartTotals.itemCount || 0;
}

// Initialize Cart
async function initializeCart() {
    const isLoggedIn = !!window.__turkesaCustomer?.loggedIn;

    await refreshCartFromShopify({ skipPersist: true });

    if (cartTotals.itemCount === 0 && shouldClearCartAfterCheckout()) {
        clearSavedCartSnapshots();
        return;
    }

    if (!isLoggedIn) {
        // Guests: keep Shopify cart; restore snapshot only if cart is empty.
        if (cartTotals.itemCount === 0) {
            await restoreSavedCartIfNeeded();
        }
        return;
    }

    // Logged in: restore per-user cart snapshot if needed
    await restoreSavedCartIfNeeded();
}

// Bind Shopify product forms to AJAX add-to-cart and drawer
function bindAjaxProductForms() {
    const productForms = document.querySelectorAll('form[action="/cart/add"]');
    productForms.forEach(form => {
        if (form.dataset.ajaxBound === 'true') return;
        form.dataset.ajaxBound = 'true';

        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const submitBtn = form.querySelector('button[type="submit"], .product-add');
            if (submitBtn) submitBtn.disabled = true;

            try {
                const formData = new FormData(form);
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: formData
                });

                if (!response.ok) throw new Error('Erro ao adicionar ao carrinho');

                await refreshCartFromShopify();
                showCartSidebar();
            } catch (error) {
                console.error(error);
                alert('Não foi possível adicionar ao carrinho. Tenta novamente.');
            } finally {
                if (submitBtn) submitBtn.disabled = false;
            }
        });
    });
}

// Show Cart Sidebar
function showCartSidebar() {
    const cartSidebar = document.getElementById('cartSidebar');
    const cartOverlay = document.getElementById('cartOverlay');
    refreshCartFromShopify();
    cartSidebar.classList.add('active');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

// Hide Cart Sidebar
function hideCartSidebar() {
    const cartSidebar = document.getElementById('cartSidebar');
    const cartOverlay = document.getElementById('cartOverlay');
    cartSidebar.classList.remove('active');
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
}

// Initialize Cookie Banner
function initializeCookieBanner() {
    const banner = document.getElementById('cookieConsent');
    if (!banner) return; // Some pages don't render the cookie banner

    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
        setTimeout(() => {
            banner.classList.add('show');
        }, 1000);
    }
}

// Accept Cookies
function acceptCookies() {
    localStorage.setItem('cookieConsent', 'accepted');
    const banner = document.getElementById('cookieConsent');
    if (banner) {
        banner.classList.remove('show');
    }
}

// Manage Cookies (placeholder)
function manageCookies() {
    alert('Funcionalidade de gestão de cookies em desenvolvimento. Por agora, pode aceitar todos os cookies.');
    acceptCookies();
}

// Filter Products
function filterProducts(filter) {
    const allProducts = document.querySelectorAll('.product-card');
    const filterBtns = document.querySelectorAll('.filter-btn');

    filterBtns.forEach(btn => btn.classList.remove('active'));
    event.target.classList.add('active');

    if (filter === 'all') {
        allProducts.forEach(product => product.style.display = 'block');
    } else if (filter === 'new') {
        allProducts.forEach(product => {
            product.style.display = product.dataset.label === 'new' ? 'block' : 'none';
        });
    } else if (filter === 'sale') {
        allProducts.forEach(product => {
            product.style.display = product.dataset.label === 'sale' ? 'block' : 'none';
        });
    }
}

// Helper to navigate or filter categories safely
function navigateToCategory(category, subcategory = null) {
    const productGrid = document.getElementById('productGrid');
    if (productGrid) {
        filterByCategory(category, subcategory);
        const productsSection = document.getElementById('products');
        if (productsSection) {
            productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    } else {
        const params = new URLSearchParams();
        params.set('category', subcategory ? `${category}-${subcategory}` : category);
        window.location.href = '/?' + params.toString();
    }
}

// Filter Products by Category with smooth transitions
function filterByCategory(category, subcategory = null) {
    const allProducts = document.querySelectorAll('.product-card');
    const productsHeader = document.querySelector('.products-header h2');
    const productGrid = document.getElementById('productGrid');
    const productsSection = document.getElementById('products');
    const breadcrumbCategory = document.getElementById('breadcrumbCategory');

    // Toggle filtering mode (hide hero/categories sections)
    const isFiltering = category !== 'all' || subcategory !== null;
    if (isFiltering) {
        document.body.classList.add('filtering-active');
    } else {
        document.body.classList.remove('filtering-active');
    }

    // If grid not on page, redirect to home with query params
    if (!productGrid) {
        const params = new URLSearchParams();
        params.set('category', subcategory ? `${category}-${subcategory}` : category);
        window.location.href = '/?' + params.toString();
        return;
    }

    // Add loading state
    productGrid.classList.add('loading');

    // Fade out products that will be hidden
    allProducts.forEach(product => {
        const productCategory = product.dataset.category;
        const productSubcategory = product.dataset.subcategory;
        let shouldShow = false;

        if (category === 'all') {
            shouldShow = true;
        } else if (subcategory) {
            shouldShow = (productCategory === category && productSubcategory === subcategory);
        } else {
            shouldShow = productCategory === category;
        }

        if (!shouldShow) {
            product.classList.add('hiding');
        }
    });

    // Wait for fade out animation, then filter
    setTimeout(() => {
        let visibleCount = 0;

        allProducts.forEach(product => {
            const productCategory = product.dataset.category;
            const productSubcategory = product.dataset.subcategory;
            let shouldShow = false;

            if (category === 'all') {
                shouldShow = true;
            } else if (subcategory) {
                shouldShow = (productCategory === category && productSubcategory === subcategory);
            } else {
                shouldShow = productCategory === category;
            }

            // Update display and remove hiding class
            product.style.display = shouldShow ? 'block' : 'none';
            product.classList.remove('hiding');

            if (shouldShow) visibleCount++;
        });

        // Remove any existing "no products" message
        const existingMessage = productGrid.querySelector('.no-products-message');
        if (existingMessage) {
            existingMessage.remove();
        }

        // Show message if no products found
        if (visibleCount === 0) {
            const message = document.createElement('div');
            message.className = 'no-products-message';
            message.style.cssText = 'grid-column: 1 / -1; text-align: center; padding: 60px 20px; color: #666; font-size: 18px;';
            message.textContent = 'Nenhum produto encontrado nesta categoria.';
            productGrid.appendChild(message);
        }

        // Remove loading state
        productGrid.classList.remove('loading');

        // Update section title based on filter
        if (productsHeader) {
            const titles = {
                'all': 'Produtos em Destaque',
                'women': 'Mulher',
                'women-dresses': 'Vestidos',
                'women-tops': 'Tops & Camisas',
                'women-bottoms': 'Calças & Saias',
                'women-outerwear': 'Casacos',
                'women-knitwear': 'Malhas',
                'men': 'Homem',
                'accessories': 'Acessórios'
            };

            const breadcrumbTitles = {
                'all': 'Produtos',
                'women': 'Mulher',
                'women-dresses': 'Mulher / Vestidos',
                'women-tops': 'Mulher / Tops & Camisas',
                'women-bottoms': 'Mulher / Calças & Saias',
                'women-outerwear': 'Mulher / Casacos',
                'women-knitwear': 'Mulher / Malhas',
                'men': 'Homem',
                'accessories': 'Acessórios'
            };

            const pageTitles = {
                'all': 'Turkesa - Fashion Store',
                'women': 'Mulher - Turkesa',
                'women-dresses': 'Vestidos - Mulher - Turkesa',
                'women-tops': 'Tops & Camisas - Mulher - Turkesa',
                'women-bottoms': 'Calças & Saias - Mulher - Turkesa',
                'women-outerwear': 'Casacos - Mulher - Turkesa',
                'women-knitwear': 'Malhas - Mulher - Turkesa',
                'men': 'Homem - Turkesa',
                'accessories': 'Acessórios - Turkesa'
            };

            const titleKey = subcategory ? `${category}-${subcategory}` : category;
            productsHeader.textContent = titles[titleKey] || 'Produtos em Destaque';

            // Update breadcrumb
            if (breadcrumbCategory) {
                breadcrumbCategory.textContent = breadcrumbTitles[titleKey] || 'Produtos';
            }

            // Update page title for SEO
            document.title = pageTitles[titleKey] || 'Turkesa - Fashion Store';
        }

        // Smart scrolling based on context
        if (isFiltering) {
            // When filtering, scroll to top to show clean product listing
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            // When showing all products (landing page), check if we need to scroll
            const rect = productsSection.getBoundingClientRect();
            const isInView = rect.top >= 0 && rect.top <= window.innerHeight;

            if (!isInView) {
                productsSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }, 300);
}

// Handle Hash Navigation
function handleHashNavigation() {
    const hash = window.location.hash;
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category');

    // Check for query parameter first (e.g., ?category=women-dresses)
    if (category) {
        if (category.startsWith('women-')) {
            const subcategory = category.replace('women-', '');
            filterByCategory('women', subcategory);
        } else if (category === 'women' || category === 'men' || category === 'accessories') {
            filterByCategory(category);
        } else {
            filterByCategory('all');
        }
    }
    // Otherwise check hash navigation
    else if (hash.startsWith('#women-')) {
        const subcategory = hash.replace('#women-', '');
        filterByCategory('women', subcategory);
    } else if (hash === '#women') {
        filterByCategory('women');
    } else if (hash === '#men') {
        filterByCategory('men');
    } else if (hash === '#accessories') {
        filterByCategory('accessories');
    } else if (hash === '#products' || hash === '') {
        // Only filter to all if not already filtered
        const currentTitle = document.querySelector('.products-header h2')?.textContent;
        if (!currentTitle || currentTitle === 'Produtos em Destaque') {
            // Don't re-filter if already showing all products
        }
    }
}

function resetMobileSubmenus() {
    document.querySelectorAll('.nav-item.has-submenu').forEach(item => {
        const submenu = item.querySelector('.submenu');
        item.classList.remove('open');
        if (submenu) {
            submenu.style.maxHeight = null;
            submenu.style.opacity = '';
        }
    });
    document.querySelectorAll('.site-nav .nav-item.has-dropdown').forEach(item => {
        item.classList.remove('open');
    });
}

function setupMobileSubmenus() {
    const isMobile = () => window.innerWidth <= 980;
    const items = document.querySelectorAll('.nav-item.has-submenu');

    console.log('Setting up mobile submenus. Found items:', items.length);

    items.forEach((item, index) => {
        const link = item.querySelector(':scope > a');
        if (!link) {
            console.log('No link found for item', index);
            return;
        }

        // Remove old listeners if rebinding
        if (link.dataset.submenuBound === 'true') {
            console.log('Already bound, skipping item', index);
            return;
        }
        link.dataset.submenuBound = 'true';

        console.log('Binding submenu for:', link.textContent.trim());

        const handler = (e) => {
            if (!isMobile()) {
                console.log('Not mobile, allowing default behavior');
                return;
            }

            console.log('Mobile submenu click/touch:', e.type, 'on', link.textContent.trim());

            const now = Date.now();
            if (e.type === 'touchstart') {
                link.dataset.lastTouch = String(now);
                console.log('Touch started');
            } else if (e.type === 'click') {
                const lastTouch = Number(link.dataset.lastTouch || 0);
                if (lastTouch && now - lastTouch < 400) {
                    console.log('Click after touch, preventing');
                    e.preventDefault();
                    return;
                }
            }

            const isOpen = item.classList.contains('open');
            console.log('Submenu is open:', isOpen);

            if (!isOpen) {
                e.preventDefault();
                e.stopPropagation();
                // Close other open submenus
                document.querySelectorAll('.nav-item.has-submenu.open').forEach(openItem => {
                    if (openItem !== item) {
                        console.log('Closing other submenu');
                        openItem.classList.remove('open');
                    }
                });
                item.classList.add('open');
                console.log('Opened submenu for:', link.textContent.trim());
            } else {
                // Already open: allow navigation and close menu after navigating
                console.log('Allowing navigation to:', link.getAttribute('href'));
                setTimeout(() => {
                    if (typeof window.turkesaCloseMobileMenu === 'function') {
                        window.turkesaCloseMobileMenu();
                    }
                }, 0);
            }
        };

        // Use capture phase to ensure we catch the event first
        link.addEventListener('touchstart', handler, { passive: false, capture: true });
        link.addEventListener('click', handler, { capture: true });

        console.log('Event listeners attached for:', link.textContent.trim());
    });

    console.log('Mobile submenus setup complete');
}

// Debug functions - call in console to manually test
window.turkesaTestMenu = function(menuName) {
    const menuMap = {
        'novidades': 0,
        'colecao': 1,
        'outlet': 2
    };

    const index = menuMap[menuName.toLowerCase()] || 0;
    const items = document.querySelectorAll('.nav-item.has-submenu');

    if (items[index]) {
        // Close all others
        items.forEach(item => item.classList.remove('open'));
        // Open this one
        items[index].classList.add('open');
        console.log(`✅ Opened ${menuName} menu`);
        console.log('Submenu element:', items[index].querySelector('.submenu'));
        console.log('Submenu classes:', items[index].className);
    } else {
        console.log('❌ Menu not found. Try: novidades, colecao, or outlet');
    }
};

// Force open all menus - for testing CSS
window.turkesaOpenAll = function() {
    document.querySelectorAll('.nav-item.has-submenu').forEach((item, i) => {
        item.classList.add('open');
        console.log(`Opened menu ${i}`);
    });
};

// Close all menus
window.turkesaCloseAll = function() {
    document.querySelectorAll('.nav-item.has-submenu').forEach(item => {
        item.classList.remove('open');
    });
    console.log('Closed all menus');
};

// Debug info
window.turkesaDebugMenus = function() {
    const items = document.querySelectorAll('.nav-item.has-submenu');
    console.log('=== TURKESA MENU DEBUG ===');
    console.log(`Found ${items.length} menu items with submenus`);
    console.log(`Window width: ${window.innerWidth}px (mobile: ${window.innerWidth <= 980 ? 'YES' : 'NO'})`);

    items.forEach((item, i) => {
        const link = item.querySelector(':scope > a');
        const submenu = item.querySelector('.submenu');
        const isOpen = item.classList.contains('open');

        console.log(`\n[${i}] ${link ? link.textContent.trim() : 'NO LINK'}`);
        console.log(`   - Has submenu: ${!!submenu}`);
        console.log(`   - Is open: ${isOpen}`);
        console.log(`   - Classes: ${item.className}`);
        if (submenu) {
            const styles = window.getComputedStyle(submenu);
            console.log(`   - Max-height: ${styles.maxHeight}`);
            console.log(`   - Opacity: ${styles.opacity}`);
            console.log(`   - Visibility: ${styles.visibility}`);
        }
    });

    console.log('\n=== EVENT HANDLER ===');
    console.log('Handler exists:', !!window.turkesaSubmenuHandler);
    console.log('\nTry: turkesaTestMenu("novidades") or turkesaOpenAll()');
};

function initializeMobileNav() {
    const navbarContainer = document.querySelector('.navbar .container');
    const mainNav = document.getElementById('mainNav');

    let toggleBtn = document.getElementById('mobileMenuToggle');

    // If there's no nav to open, hide/remove the toggle and exit early
    if (!navbarContainer || !mainNav) {
        if (toggleBtn) {
            toggleBtn.style.display = 'none';
        }
        return;
    }

    // Create the toggle if markup was not present
    if (!toggleBtn) {
        toggleBtn = document.createElement('button');
        toggleBtn.className = 'mobile-menu-toggle';
        toggleBtn.id = 'mobileMenuToggle';
        toggleBtn.setAttribute('aria-label', 'Abrir menu');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.innerHTML = '<span></span><span></span><span></span>';
        navbarContainer.insertBefore(toggleBtn, navbarContainer.firstChild);
    }

    let overlay = document.getElementById('mobileNavOverlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'mobileNavOverlay';
        overlay.className = 'mobile-nav-overlay';
        document.body.appendChild(overlay);
    }

    const openMenu = () => {
        mainNav.classList.add('open');
        overlay.classList.add('active');
        toggleBtn.classList.add('active');
        toggleBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('menu-open');
    };

    const closeMenu = () => {
        mainNav.classList.remove('open');
        overlay.classList.remove('active');
        toggleBtn.classList.remove('active');
        toggleBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
        resetMobileSubmenus();
    };

    // Expose menu controls for other handlers (e.g., logo tap)
    window.turkesaOpenMobileMenu = openMenu;
    window.turkesaCloseMobileMenu = closeMenu;
    window.turkesaToggleMobileMenu = () => {
        if (mainNav.classList.contains('open')) {
            closeMenu();
        } else {
            openMenu();
        }
    };

    // Setup mobile submenus FIRST before other event listeners
    setupMobileSubmenus();

    toggleBtn.addEventListener('click', () => {
        if (mainNav.classList.contains('open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    overlay.addEventListener('click', closeMenu);

    document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && mainNav.classList.contains('open')) {
            closeMenu();
        }
    });

    // Only close menu for links that DON'T have submenus
    document.querySelectorAll('.nav-links > li:not(.has-submenu) > a').forEach(link => {
        if (link.dataset.mobileCloseBound === 'true') return;
        link.dataset.mobileCloseBound = 'true';

        link.addEventListener('click', () => {
            if (window.innerWidth <= 980) {
                closeMenu();
            }
        });
    });

    document.querySelectorAll('.submenu a').forEach(link => {
        if (link.dataset.mobileSubCloseBound === 'true') return;
        link.dataset.mobileSubCloseBound = 'true';

        link.addEventListener('click', () => {
            if (window.innerWidth <= 980) {
                closeMenu();
            }
        });
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth > 980) {
            closeMenu();
        }
    });
}

function initializeHeaderHoverDropdowns() {
    const items = Array.from(document.querySelectorAll('.site-nav .nav-item.has-dropdown'));
    if (!items.length) return;

    const isDesktop = () => window.innerWidth > 980;
    let closeTimer;

    const closeAll = () => {
        items.forEach(i => i.classList.remove('open'));
    };

    const bindItem = (item) => {
        if (item.dataset.hoverBound === 'true') return;
        item.dataset.hoverBound = 'true';

        const trigger = item.querySelector('.nav-trigger');
        const dropdown = item.querySelector('.dropdown-menu');
        if (!trigger || !dropdown) return;

        const open = () => {
            if (!isDesktop()) return;
            clearTimeout(closeTimer);
            closeAll();
            item.classList.add('open');
        };

        const scheduleClose = () => {
            if (!isDesktop()) return;
            clearTimeout(closeTimer);
            closeTimer = setTimeout(() => item.classList.remove('open'), 120);
        };

        trigger.addEventListener('mouseenter', open);
        trigger.addEventListener('focus', open);
        item.addEventListener('mouseleave', scheduleClose);
        dropdown.addEventListener('mouseenter', () => clearTimeout(closeTimer));
        dropdown.addEventListener('mouseleave', scheduleClose);

        const toggleMobile = (e) => {
            if (isDesktop()) return;
            // In mobile, allow navigation to the link URL instead of toggling dropdown
            // since dropdowns are hidden via CSS in mobile
            return;
        };

        trigger.addEventListener('click', toggleMobile, { capture: true });
        trigger.addEventListener('touchstart', toggleMobile, { passive: false, capture: true });
    };

    items.forEach(bindItem);

    window.addEventListener('resize', () => {
        if (!isDesktop()) {
            closeAll();
        }
    });
}

// Initialize Event Listeners
function initializeEventListeners() {
    // Cart Button
    const cartBtn = document.getElementById('cartBtn');
    if (cartBtn) {
        cartBtn.addEventListener('click', showCartSidebar);
    }
    // Any element with data-open-cart opens the drawer (usable anywhere)
    document.querySelectorAll('[data-open-cart]').forEach(trigger => {
        if (trigger.dataset.cartOpenBound === 'true') return;
        trigger.dataset.cartOpenBound = 'true';
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            showCartSidebar();
        });
    });

    // Close Cart
    const closeCart = document.getElementById('closeCart');
    if (closeCart) {
        closeCart.addEventListener('click', hideCartSidebar);
    }

    // Cart Overlay
    const cartOverlay = document.getElementById('cartOverlay');
    if (cartOverlay) {
        cartOverlay.addEventListener('click', hideCartSidebar);
    }

    // Cookie Consent
    const acceptCookiesBtn = document.getElementById('acceptCookies');
    if (acceptCookiesBtn) {
        acceptCookiesBtn.addEventListener('click', acceptCookies);
    }

    const manageCookiesBtn = document.getElementById('manageCookies');
    if (manageCookiesBtn) {
        manageCookiesBtn.addEventListener('click', manageCookies);
    }

    // Filter Buttons
    const filterButtons = document.querySelectorAll('.filter-btn');
    filterButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const filter = e.target.dataset.filter;
            filterProducts(filter);
        });
    });

    // Breadcrumb Home Link
    const breadcrumbHome = document.getElementById('breadcrumbHome');
    if (breadcrumbHome) {
        breadcrumbHome.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.hash = '';
            filterByCategory('all');
        });
    }

    // Logo Link - Return to Landing Page
    const logoLink = document.getElementById('logoLink') || document.querySelector('.logo a');
    if (logoLink) {
        logoLink.addEventListener('click', (e) => {
            const productGrid = document.getElementById('productGrid');

            if (productGrid) { // Already on landing page
                e.preventDefault();
                window.location.hash = '';
                filterByCategory('all');
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            // Other pages keep default navigation to index.html
        });
    }

    // Search Button - Open Modal
    const searchBtn = document.getElementById('searchBtn');
    if (searchBtn) {
        searchBtn.addEventListener('click', () => {
            showSearchModal();
        });
    }

    // Newsletter Form
    const newsletterForm = document.querySelector('.newsletter-form');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const email = e.target.querySelector('input[type="email"]').value;
            alert(`Obrigado por subscrever! Enviaremos novidades para ${email}`);
            e.target.reset();
        });
    }

    // Smooth Scroll and Category Navigation
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            // Handle category/subcategory links
            if (href.startsWith('#women-') || href === '#women' || href === '#men' || href === '#accessories') {
                e.preventDefault();
                window.location.hash = href;
                handleHashNavigation();
            } else {
                // Handle regular smooth scroll
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }

                // Close mobile menu if open and on mobile
                if (window.innerWidth <= 980 && typeof window.turkesaCloseMobileMenu === 'function') {
                    setTimeout(() => window.turkesaCloseMobileMenu(), 300);
                }
            }
        });
    });

    // Hash Change Event
    window.addEventListener('hashchange', handleHashNavigation);

    // Initial hash navigation on page load
    if (window.location.hash) {
        handleHashNavigation();
    }
}

// Checkout - Redirect to checkout page
document.addEventListener('DOMContentLoaded', () => {
    const checkoutBtn = document.querySelector('.checkout-btn');
    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', () => {
            if (!cartTotals.itemCount) {
                alert('O seu carrinho está vazio!');
                return;
            }
            // Redirect to checkout page
            window.location.href = getDiscountCheckoutUrl();
        });
    }
});

// Initialize Announcement Bar Scroll Behavior
function initializeAnnouncementBarScroll() {
    const announcementBar = document.querySelector('.announcement-bar');
    const header = document.querySelector('.header');
    const siteHeader = document.querySelector('.site-header');
    if (!announcementBar && !siteHeader) return;

    let ticking = false;

    const updateHeaderHeight = () => {
        if (!siteHeader) return;
        const height = siteHeader.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--site-header-height', `${height}px`);
    };

    if (siteHeader && 'ResizeObserver' in window) {
        const headerObserver = new ResizeObserver(() => updateHeaderHeight());
        headerObserver.observe(siteHeader);
    }

    function handleScroll() {
        const scrollY = window.scrollY || window.pageYOffset;

        if (announcementBar) {
            if (scrollY > 0) {
                // Hide announcement bar
                announcementBar.classList.add('hidden');

                // Move header to top
                if (header) header.style.top = '0';
            } else {
                // Show announcement bar
                announcementBar.classList.remove('hidden');

                // Move header below announcement bar
                const barHeight = announcementBar.offsetHeight;
                if (header) header.style.top = barHeight + 'px';
            }
        }

        updateHeaderHeight();
        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(handleScroll);
            ticking = true;
        }
    }, { passive: true });

    // Initialize - header starts below announcement bar
    if (announcementBar && header) {
        const barHeight = announcementBar.offsetHeight;
        header.style.top = barHeight + 'px';
    }
    updateHeaderHeight();

    window.addEventListener('resize', () => {
        updateHeaderHeight();
    });
}

// Discount Popup Functionality
function initDiscountPopup() {
    const popupOverlay = document.getElementById('discountPopupOverlay');
    const emailInput = document.getElementById('popupEmail');
    const submitBtn = document.getElementById('popupSubmit');
    const noBtn = document.querySelector('.popup-btn-no');
    const popupLangBtns = document.querySelectorAll('.popup-lang-btn');

    if (!popupOverlay) return;
    const popupForm = document.getElementById('popupNewsletterForm');
    const successMessage = popupOverlay.querySelector('[data-popup-success]');

    const setSubmitState = (isLoading) => {
        if (!submitBtn) return;
        submitBtn.disabled = isLoading;
        submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    };

    const clearPopupNotice = () => {
        if (successMessage) {
            successMessage.hidden = true;
        }
    };

    // Initialize popup language selector with current language
    function initPopupLanguage() {
        const currentLang = window.TurkesaLanguage?.getCurrentLanguage() || localStorage.getItem('turkesa-language') || 'pt';
        popupLangBtns.forEach(btn => {
            if (btn.getAttribute('data-popup-lang') === currentLang) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }

    // Handle popup language switching
    popupLangBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const selectedLang = btn.getAttribute('data-popup-lang');

            // Update active state
            popupLangBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            // Update language globally
            if (window.TurkesaLanguage) {
                window.TurkesaLanguage.setLanguage(selectedLang);
                localStorage.setItem('turkesa-language', selectedLang);
            }
        });
    });

    // Initialize language selector
    initPopupLanguage();

    // Check if popup has been shown before
    const popupShown = sessionStorage.getItem('discountPopupShown');

    // Show popup after 1 second if not shown in this session
    if (!popupShown) {
        setTimeout(() => {
            clearPopupNotice();
            setSubmitState(false);
            popupOverlay.classList.add('active');
            document.body.style.overflow = 'hidden'; // Prevent scrolling
            // Ensure language is initialized when popup shows
            initPopupLanguage();
        }, 1000);
    }

    // Close popup function
    function closePopup() {
        popupOverlay.classList.remove('active');
        document.body.style.overflow = ''; // Re-enable scrolling
        sessionStorage.setItem('discountPopupShown', 'true');
    }

    // Email validation
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const submitPopupEmail = async (email) => {
        if (!popupForm) return true;
        const formData = new FormData(popupForm);
        formData.set('contact[email]', email);
        if (!formData.get('contact[tags]')) {
            formData.set('contact[tags]', 'newsletter, popup-5-off');
        }

        try {
            const response = await fetch(popupForm.action || '/contact', {
                method: 'POST',
                body: formData,
                headers: { 'Accept': 'application/json' },
                credentials: 'same-origin'
            });
            return response.ok;
        } catch (error) {
            console.warn('Popup newsletter signup failed', error);
            return false;
        }
    };

    const handlePopupSubmit = async (event) => {
        if (event) event.preventDefault();
        if (!emailInput || !submitBtn) return;
        clearPopupNotice();

        const email = emailInput.value.trim();

        if (!email) {
            emailInput.style.borderColor = '#ff6b6b';
            emailInput.focus();
            return;
        }

        if (!isValidEmail(email)) {
            emailInput.style.borderColor = '#ff6b6b';
            emailInput.focus();
            return;
        }

        setSubmitState(true);
        console.log('User accepted popup discount with email:', email);
        discountStorage.set(DISCOUNT_EMAIL_KEY, email.toLowerCase());
        discountStorage.set(DISCOUNT_ELIGIBLE_KEY, 'true');
        const popupCode = normalizeDiscountCode(getPopupDiscountCode());
        if (isValidDiscountCode(popupCode)) {
            setStoredDiscountCode(popupCode);
        }
        await submitPopupEmail(email);
        if (successMessage) successMessage.hidden = false;
        setTimeout(closePopup, 1200);
    };

    if (popupForm) {
        popupForm.addEventListener('submit', handlePopupSubmit);
    } else if (submitBtn && emailInput) {
        submitBtn.addEventListener('click', handlePopupSubmit);
    }

    if (emailInput) {
        // Reset border color on input
        emailInput.addEventListener('input', () => {
            emailInput.style.borderColor = '#e0e0e0';
            clearPopupNotice();
        });
    }

    // No button - decline discount
    if (noBtn) {
        noBtn.addEventListener('click', closePopup);
    }

    // Prevent closing by clicking outside - user must use buttons
    popupOverlay.addEventListener('click', (e) => {
        // Do nothing - user must click one of the buttons
        e.stopPropagation();
    });

    // Allow clicking inside the modal without closing
    const popupModal = document.querySelector('.popup-modal');
    if (popupModal) {
        popupModal.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    }
}

// Initialize discount popup when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountPopup);
} else {
    initDiscountPopup();
}

// Search Modal Functionality
function showSearchModal() {
    const searchModalOverlay = document.getElementById('searchModalOverlay');
    const searchModalInput = document.getElementById('searchModalInput');

    if (searchModalOverlay) {
        searchModalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Focus on input after a short delay to allow animation
        setTimeout(() => {
            if (searchModalInput) {
                searchModalInput.focus();
            }
        }, 100);
    }
}

function hideSearchModal() {
    const searchModalOverlay = document.getElementById('searchModalOverlay');
    const searchModalInput = document.getElementById('searchModalInput');

    if (searchModalOverlay) {
        searchModalOverlay.classList.remove('active');
        document.body.style.overflow = '';

        // Clear input
        if (searchModalInput) {
            searchModalInput.value = '';
        }
    }
}

function performSearch() {
    const searchModalInput = document.getElementById('searchModalInput');
    const searchTerm = searchModalInput ? searchModalInput.value.trim().toLowerCase() : '';
    const productGrid = document.getElementById('productGrid');

    const normalize = (str) => (str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const term = normalize(searchTerm);

    // If we have a product grid on the page, filter it in-place (Ctrl+F style)
    if (productGrid) {
        const cards = productGrid.querySelectorAll('.product-card');
        let matches = 0;

        if (!term) {
            // Empty term: show everything again
            cards.forEach(card => card.style.display = 'block');
        } else {
            cards.forEach(card => {
                const title = normalize(card.querySelector('.product-title')?.textContent);
                const visible = title.includes(term);
                card.style.display = visible ? 'block' : 'none';
                if (visible) matches++;
            });
        }

        // Remove existing "no results" message
        const existingMessage = productGrid.querySelector('.no-products-message');
        if (existingMessage) existingMessage.remove();

        // If no matches, show a friendly message
        if (matches === 0 && term) {
            const message = document.createElement('div');
            message.className = 'no-products-message';
            message.style.cssText = 'grid-column: 1 / -1; text-align: center; padding: 40px 20px; color: #666; font-size: 16px;';
            message.textContent = 'Sem resultados para "' + searchTerm + '".';
            productGrid.appendChild(message);
        }

        hideSearchModal();

        // Scroll to products section if present
        const productsSection = document.getElementById('products');
        if (productsSection) {
            productsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    } else {
        // Fallback: go to Shopify search results page (products only)
        if (searchTerm) {
            window.location.href = '/search?type=product&q=' + encodeURIComponent(searchTerm);
        } else {
            hideSearchModal();
        }
    }
}

// Initialize Search Modal
function initSearchModal() {
    const searchModalOverlay = document.getElementById('searchModalOverlay');
    const searchModalClose = document.getElementById('searchModalClose');
    const searchModalBtn = document.getElementById('searchModalBtn');
    const searchModalInput = document.getElementById('searchModalInput');

    // Close button
    if (searchModalClose) {
        searchModalClose.addEventListener('click', hideSearchModal);
    }

    // Search button
    if (searchModalBtn) {
        searchModalBtn.addEventListener('click', performSearch);
    }

    // Enter key in input
    if (searchModalInput) {
        searchModalInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                performSearch();
            }
        });
    }

    // Click overlay to close
    if (searchModalOverlay) {
        searchModalOverlay.addEventListener('click', (e) => {
            if (e.target === searchModalOverlay) {
                hideSearchModal();
            }
        });
    }
}

// Initialize search modal when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchModal);
} else {
    initSearchModal();
}

// Override WhatsApp message text set in theme markup.
(function() {
    const btn = document.getElementById('whatsappButton');
    if (!btn) return;

    const message = 'Olá! Gostaria de mais informações.';
    const numbersAttr = btn.getAttribute('data-whatsapp-numbers') || '351938066928';
    const numbers = numbersAttr
        .split(',')
        .map((number) => number.trim())
        .filter(Boolean);

    if (!numbers.length) return;

    btn.setAttribute('data-whatsapp-message', message);

    const messageQuery = '?text=' + encodeURIComponent(message);
    btn.setAttribute('href', 'https://wa.me/' + numbers[0] + messageQuery);

    btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        numbers.forEach((number) => {
            window.open('https://wa.me/' + number + messageQuery, '_blank', 'noopener');
        });
    }, true);
})();
